import React from "react";

export default function Step5() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          5
        </div>
        <h1 className="">
          Chegou a hora de informar seu e-mail e escolher uma senha para a sua
          conta.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3608.jpg?alt=media&token=fac1ec8a-fde1-4240-9b70-095b2460d8f4"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
